import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconamoonEditFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.20964 16.667L4.16797 20.8337L8.33464 19.792L20.4034 7.72325C20.7939 7.33257 21.0134 6.80276 21.0134 6.25034C21.0134 5.69791 20.7939 5.1681 20.4034 4.77742L20.2242 4.59825C19.8335 4.20769 19.3037 3.98828 18.7513 3.98828C18.1989 3.98828 17.6691 4.20769 17.2784 4.59825L5.20964 16.667Z",
			stroke: "#B9F833",
			strokeWidth: 2.08333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.20964 16.6667L4.16797 20.8333L8.33464 19.7917L18.7513 9.375L15.6263 6.25L5.20964 16.6667Z",
			fill: "#B9F833"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6263 6.25L18.7513 9.375M13.543 20.8333H21.8763",
			stroke: "#B9F833",
			strokeWidth: 2.08333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconamoonEditFill;
